import { isEmpty } from 'lodash'
import { IVehicleProperties, IVehicleInfo } from '../types/vehicleTypes'
import { ISystemSetting } from '../types/baseTypes'
import { VEHICLE_PROPERTIES_TO_HIDE } from 'common/constants'

export const getVehicleDetailProperties = (vehicleInfo: IVehicleInfo, retailView: boolean = false) =>
  retailView
    ? vehicleInfo?.Properties?.filter((p) => p.ID === 1 && !VEHICLE_PROPERTIES_TO_HIDE.includes(p.UIConstantName))
    : vehicleInfo?.Properties?.filter((p) => p.ID === 1)

export const processInServiceDateProperty = (
  properties: IVehicleProperties[],
  vehicleSrcCode: string,
  setting: ISystemSetting
) => {
  return properties?.filter((p) => {
    if (p.UIConstantName !== 'IN_SERVICE_DATE') return true

    /**
     * setting
     *   Value:
     *     0       : Hide
     *     1       : Show (check setting.ValueString)
     *
     *   ValueString:
     *       BMWFS   : ShowInServiceDateForOffleaseCar
     *       BMWNA   : ShowInServiceDateForCompanyCar
     *       <blank> : ShowInServiceDateForBothOffleaseAndCompanyCars
     */

    return (
      setting.Value === '1' &&
      (isEmpty(setting.ValueString) || setting.ValueString.toLowerCase() === vehicleSrcCode.toLowerCase())
    )
  })
}

const transliterate = (c: string) => {
  return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10
}

const get_check_digit = (vin: string) => {
  var map = '0123456789X'
  var weights = '8765432X098765432'
  var sum = 0
  for (var i = 0; i < 17; ++i) sum += transliterate(vin[i]) * map.indexOf(weights[i])
  return map[sum % 11]
}

export const validate = (vin: string) => {
  vin = vin.toUpperCase()
  if (vin.length !== 17) return false
  if (/^(.)\1+$/.test(vin)) return false
  return get_check_digit(vin) === vin[8]
}
